import { InverseHeader } from '@jouzen/ecom-components/layout';

import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

const IntegrationsHero = () => {
  return (
    <InverseHeader enter>
      <LandingPageHero
        backgroundImage={{
          localizedAlt: 'heart_health_man_closeup_alt',
          srcSet: [
            {
              media: '(max-width: 1023px)',
              src: '/integrations/hero-mobile.jpg',
            },
            {
              media: '(min-width: 1024px) and (orientation: landscape)',
              src: '/integrations/hero-desktop.jpg',
            },
            {
              media: '(max-width: 1199px) and (orientation: portrait)',
              src: '/integrations/hero-mobile.jpg',
            },
          ],
        }}
        backgroundProps={{
          color: 'sandstone-200',
          gradients: [],
        }}
        copy="integrations_hero_copy"
        data-cy="integrations-hero"
        eyebrow="integrations_hero_eyebrow"
        textColor="text-sandstone-200"
        title="integrations_hero_title"
        titleProps={{
          indentation: 'lg:pl-28',
          typographyProps: {
            className: 'lg:en:whitespace-nowrap',
          },
        }}
      />
    </InverseHeader>
  );
};

export default IntegrationsHero;
